import { assert, isFunction } from '../validation/index.mjs';
/**
 * Error tuple, go-style.
 *
 * @param fn async function to run
 *
 * @example
 *
 * const [result, error] = await attempt(async () => {
 *     return 'hello';
 * });
 *
 * if (error) {
 *     console.error(error);
 * }
 *
 * console.log(result);
 */ export const attempt = async (fn)=>{
    assert(isFunction(fn), 'fn must be a function');
    try {
        return [
            await fn(),
            null
        ];
    } catch (e) {
        return [
            null,
            e
        ];
    }
};
/**
 * Synchronous error tuple, go-style.
 *
 * @example
 *
 * const [result, error] = attemptSync(() => {
 *     return 'hello';
 * });
 *
 * if (error) {
 *     console.error(error);
 * }
 *
 * console.log(result);
 */ export const attemptSync = (fn)=>{
    assert(isFunction(fn), 'fn must be a function');
    try {
        return [
            fn(),
            null
        ];
    } catch (e) {
        return [
            null,
            e
        ];
    }
};
